/*
*
* @module : Donate
* @file : Donate.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Donate
*
* Created on : 15-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 29-Oct-2019
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import Translation from '../../language/Translation';

class Donate extends React.Component
{
	constructor(props)
	{
		super(props);
		this.translation = new Translation();
		this.state = {
			redirect: 0,
			translation:{
				'donate_v1':this.translation.getText('donate_v1'),
				'donate_v2':this.translation.getText('donate_v2'),
				'donate_v3':this.translation.getText('donate_v3'),
				'donate_v4':this.translation.getText('donate_v4'),
				'donate_v5':this.translation.getText('donate_v5'),
				'donate_v6':this.translation.getText('donate_v6')
			}

		};
		
		setTimeout(function()
		{
			sessionStorage.removeItem('session_id');
		});

	}

	
	componentDidMount()
	{
	}

	render()
	{
		return (
			<React.Fragment>
				<div className="content-box-area danke-area">
				<div className="default-heading">
				<h2>{this.state.translation.donate_v1}</h2>
				</div>
				<div className="paragraph-area">
				<p>{this.state.translation.donate_v2}<br/>{this.state.translation.donate_v3}</p>
				</div>
				<div className="text-center buttons-area">
					<a href="https://www.biovision.ch/nc/helfen/spenden-an-biovision/online-spenden/?utm_source=quiz&utm_medium=webapp&utm_campaign=herbstkampagne&utm_term=spende"><button className="btn btn-primary">{this.state.translation.donate_v4}</button></a>
				</div>
				<p className="text-center"><br/><Link to="/quiz-end">{this.state.translation.donate_v5}</Link></p>
				</div>
			</React.Fragment>
		);
	}
}

export default Donate